import { action } from 'satcheljs';

export const initializeAgendaMailOption = action('INITIALIZE_AGENDA_MAIL_OPTIONS');
